import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'
import useCard from './useCard'

export default function Card(props) {
  const {
    children,
    icon,
    body,
    surface,
    imgSrc,
    imageBlackout,
    ...rest
  } = props

  const {
    getCardType,
    renderComponent
  } = useCard()

  const cardType = getCardType(Object.keys(props))

  return <> {renderComponent(cardType, props)} </>
}

Card.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
  surface: PropTypes.bool,
  body: PropTypes.bool,
  imageBlackout: PropTypes.bool,
  imgSrc: PropTypes.string
}
